function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#5c9dff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -1)"
}, React.createElement("path", {
  className: "a",
  d: "M5,7H1A.945.945,0,0,1,0,6V2A.945.945,0,0,1,1,1H5A.945.945,0,0,1,6,2V6A.945.945,0,0,1,5,7Z"
}), React.createElement("rect", {
  className: "a",
  width: 8,
  height: 2,
  transform: "translate(8 1)"
}), React.createElement("rect", {
  className: "a",
  width: 8,
  height: 2,
  transform: "translate(8 5)"
}), React.createElement("rect", {
  className: "a",
  width: 16,
  height: 2,
  transform: "translate(0 9)"
}), React.createElement("rect", {
  className: "a",
  width: 16,
  height: 2,
  transform: "translate(0 13)"
}));

const SvgWindowParagraph = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgWindowParagraph, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/window_paragraph.dfd74726.svg";
export { ForwardRef as ReactComponent };